import type { IntlShape } from 'react-intl'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

export const formatChatLabel = (isoDate: string, intl: IntlShape): string => {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) {
    return isoDate
  }

  return intlDateFormatter(date, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }, intl.locale)
}

export const formatChatSubtitle = (isoDate: string, intl: IntlShape): string => {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) {
    return isoDate
  }

  const dateTimeStr = intlDateFormatter(date, {
    hour: 'numeric',
    minute: '2-digit',
    day: 'numeric',
    month: 'long',
  }, intl.locale)

  return intl.formatMessage(
    {
      id: 'lZgrKlVcD4AaPFhmGiIT',
      defaultMessage: 'Last updated at {dateTime}',
      description: 'Subtitle showing when a chat was last updated in the drawer list',
    },
    { dateTime: dateTimeStr },
  )
}
